import './Filter.scss';
import React, { useState } from 'react';
import { useStoreContext } from '../App/StoreProvider';
import Button from 'react-bootstrap/Button';
import FilterItem from './FilterItem';
import * as CarrierListActions from '../../store/actions/carrierList/carrierListActions';
import { Loading } from '../_common';

interface CarrierFiltersProps {
    abortRequest: () => void;
    onFilterToggle: () => void;
    exportCsv: () => void;
    csvLoading;
    showExportButton;
}

export const CarrierFilters = ({
    abortRequest,
    onFilterToggle,
    exportCsv,
    csvLoading,
    showExportButton,
}: CarrierFiltersProps): React.ReactElement => {
    const [activeKey, setActiveKey] = useState('0');
    const [, dispatch] = useStoreContext();

    const statusFilters: FilterItem[] = [
        { id: 1, name: 'Compliant' },
        { id: 2, name: 'Not Compliant' },
    ];

    const onSelectCompliatntStatus = value => {
        dispatch(CarrierListActions.setCompliantStatus(value == 1 ? 'Compliant' : value == 2 ? 'noncompliant' : ''));
    };

    return (
        <div className="Filter-Container">
            <div className="Filter-Header">
                <div className="Filter-HeaderIconContainer">
                    <i className="material-icons">filter_list</i>
                    <span className="Filter-HeaderTitle">Filters</span>
                </div>
                <Button
                    className="Filter-SelectAll"
                    variant="link"
                    onClick={(): void => setActiveKey(activeKey === '0' ? '1' : '0')}
                >
                    {activeKey === '0' ? 'Collapse All' : 'Expand All'}
                </Button>
            </div>
            <FilterItem
                abortRequest={abortRequest}
                title="Compliant"
                items={statusFilters}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={false}
                type="selectDropDown"
                onSelection={onSelectCompliatntStatus}
                placeHolder="Filter By Compliant"
            />
            {showExportButton && (
                <div className="Filter-Download-Container">
                    {/* {csvLoading ? <Loading /> : ''} */}
                    <i className="material-icons Filter-Download-Icon">get_app</i>
                    <Button className="Filter-SelectAll" variant="link" onClick={exportCsv}>
                        Download CSV
                    </Button>
                </div>
            )}
        </div>
    );
};
